// extracted by mini-css-extract-plugin
export default {"container":"container-X0HGyI","placeholder":"placeholder-P9L4c3"};